import Link from 'next/link';
import PropTypes from 'prop-types';
import styles from '../disclaimer/disclaimer.module.scss';
// eslint-disable-next-line import/prefer-default-export
export default function XrayMode({
  title = 'Content',
  entryId = '',
  spaceId = '',
}) {
  const lnk = `https://app.contentful.com/spaces/${spaceId}/entries/${entryId}`;
  return (
    <div className={styles.xRayModeWrapper}>
      <Link href={lnk} passHref target="_blank">
        Content Editor Template | {title}
      </Link>
    </div>
  );
}

XrayMode.propTypes = {
  title: PropTypes.string,
  entryId: PropTypes.string,
  spaceId: PropTypes.string,
};
